/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from 'react'
import { Column } from 'react-table';
import CustomTable from '../../../../widgets/table'
import Pagination from '../../../../widgets/pagination'
import { useTranslation } from 'react-i18next';

//History table section under Exception Handling area
interface HistoryProps {
  plateDetailsHistory: string[];
  columnsHistory: Column[];
  totalElementsHistory: number;
  pageHistory: number;
  totalPagesHistory: number;
  reason:string[];
  areas:string[];
  sortRemovelistHistory:string[];
  handleFilter: (key: string, value: any) => void;
  // handleHistoryFilter: (key: string, value: any) => void;
  handleHistoryPageChange: (newPage: any) => void;
  handleSort : (key: string, value: boolean) => void;
}

const HistoryDeviation: React.FC<HistoryProps> = ({
  plateDetailsHistory,
  columnsHistory,
  totalElementsHistory,
  pageHistory,
  totalPagesHistory,
  reason,
  areas,
  sortRemovelistHistory,
  handleHistoryPageChange,
  handleFilter,
  // handleHistoryFilter,
  handleSort
}) => {
  const { t } = useTranslation();

  return (
    <div>
          <div className=" mx-3 pe-2" style={{"height":"45vh"}}>
            <CustomTable
              data={plateDetailsHistory}
              columns={columnsHistory}
              isEditable={false}
              totalElements={totalElementsHistory}
              isActionVisible={false}
              isViewVisible={false}
              isSeachable={true}
              tableHead={t('deviationIncident.history')}
              showBatchFilter={false}
              showSerielNoFilter={false}
              onFilterClick={handleFilter}
              onSortClick={handleSort}
              ReasonList={reason}
              areaList={areas}
              removeSortList={sortRemovelistHistory}
            />
          </div>
          <div>
            <Pagination
              page={pageHistory}
              totalPages={totalPagesHistory}
              handlePageChange={handleHistoryPageChange}
            />
          </div>
        </div>
  )
}

export default HistoryDeviation;